/**
 * Decodes an image source just far enough to read its natural dimensions.
 * Resolves null instead of rejecting so callers can fall back to the default
 * insert box (e.g. undecodable formats).
 * @param {string} src - data URL or image URL
 * @returns {Promise<{ height: number, width: number } | null>}
 */
export const measureImageNaturalSize = (src) =>
  new Promise((resolve) => {
    const image = new Image();
    image.onload = () =>
      resolve(
        image.naturalWidth && image.naturalHeight
          ? { height: image.naturalHeight, width: image.naturalWidth }
          : null
      );
    image.onerror = () => resolve(null);
    image.src = src;
  });
